import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';
import styles from './BillingTotalMenu.styles';
import clsx from 'clsx';

const useStyles = createUseStyles(styles);

interface Props {
  activeFAS: boolean;
  activeRM: boolean;
  activeRA: boolean;
  marginFAS: string;
  marginRM: string;
  marginRA: string;
  totalFAS: number;
  totalRM: number;
  totalRA: number;
  reducFAS: number;
  reducRM: number;
  reducRA: number;
  profitFAS: number;
  profitRM: number;
  profitRA: number;
  totalPDC: number;
  commitment: number;
  leasing: boolean;
  leasingCost: number;
  onSubmit: () => void;
  triggerFAS: () => void;
  triggerRM: () => void;
  triggerRA: () => void;
  resetFASRM: () => void;
  toggleMenu: () => void;
  onInputChange: (event: any) => void;
}

const BillingTotalMenu: FC<Props> = (props) => {
  const {
    onSubmit,
    triggerFAS,
    triggerRA,
    triggerRM,
    toggleMenu,
    resetFASRM,
    onInputChange,
    activeFAS,
    activeRM,
    activeRA,
    marginFAS,
    marginRM,
    marginRA,
    totalFAS,
    totalRM,
    totalRA,
    reducFAS,
    reducRM,
    reducRA,
    profitFAS,
    profitRM,
    profitRA,
    totalPDC,
    commitment,
    leasing,
    leasingCost,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.root + ' animated bounceInRight'}>
      <div>
        <h5>%Aide</h5>
        <div
          onMouseEnter={triggerFAS}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeFAS']: activeFAS })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            FAS
          </label>
          <input
            step='5'
            min='0'
            name='marginFAS'
            value={marginFAS}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>
        <div
          onMouseEnter={triggerRM}
          onMouseLeave={resetFASRM}
          className={'alignHorizontal ' + (activeRM ? 'activeRM ' : '')}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RM
          </label>
          <input
            step='5'
            min='0'
            name='marginRM'
            value={marginRM}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>

        <div
          onMouseEnter={triggerRA}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeRA']: activeRA })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RA
          </label>
          <input
            step='5'
            min='0'
            name='marginRA'
            value={marginRA}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>
      </div>

      <div>
        <h5>
          <span className='icon icon-shopping-bag' />
          Total
        </h5>
        <div
          onMouseEnter={triggerFAS}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeFAS']: activeFAS })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            FAS
          </label>
          <input
            name='totalFAS'
            value={totalFAS}
            onChange={onInputChange}
            type='text'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
            readOnly
          />
        </div>
        <div
          onMouseEnter={triggerRM}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeRM']: activeRM })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RM
          </label>
          <input
            name='totalRM'
            value={totalRM}
            onChange={onInputChange}
            type='text'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
            readOnly
          />
        </div>
        <div
          onMouseEnter={triggerRA}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeRA']: activeRA })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RA
          </label>
          <input
            name='totalRA'
            value={totalRA}
            onChange={onInputChange}
            type='text'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
            readOnly
          />
        </div>
      </div>

      <div>
        <h5>
          <span className='icon icon-arrow-down' />
          Remise
        </h5>
        <div
          onMouseEnter={triggerFAS}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeFAS']: activeFAS })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            FAS
          </label>
          <input
            min='0'
            name='reducFAS'
            value={reducFAS}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>
        <div
          onMouseEnter={triggerRM}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeRM']: activeRM })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RM
          </label>
          <input
            min='0'
            name='reducRM'
            value={reducRM}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>
        <div
          onMouseEnter={triggerRA}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeRA']: activeRA })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RA
          </label>
          <input
            min='0'
            name='reducRA'
            value={reducRA}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>
      </div>

      <div>
        <h5>
          <span className='icon icon-arrow-up' />
          Marge
        </h5>
        <div
          onMouseEnter={triggerFAS}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeFAS']: activeFAS })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            FAS
          </label>
          <input
            name='profitFAS'
            value={profitFAS}
            onChange={onInputChange}
            type='text'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
            readOnly
          />
        </div>
        <div
          onMouseEnter={triggerRM}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeRM']: activeRM })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RM
          </label>
          <input
            name='profitRM'
            value={profitRM}
            onChange={onInputChange}
            type='text'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
            readOnly
          />
        </div>
        <div
          onMouseEnter={triggerRA}
          onMouseLeave={resetFASRM}
          className={clsx(classes.alignHorizontal, { ['activeRA']: activeRA })}
        >
          <label className='label-billing' htmlFor='inputCost'>
            RA
          </label>
          <input
            name='profitRA'
            value={profitRA}
            onChange={onInputChange}
            type='text'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
            readOnly
          />
        </div>
        <div className={classes.alignHorizontal}>
          <label className='label-billing' htmlFor='inputCost'>
            PDC
          </label>
          <input
            name='totalPDC'
            value={totalPDC}
            onChange={onInputChange}
            type='text'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
            readOnly
          />
        </div>
      </div>

      <div>
        <h5>
          <span className='icon icon-tools' />
          Option
        </h5>
        <div className={classes.alignHorizontal}>
          <label className='label-billing' htmlFor='inputCost'>
            Eng
          </label>
          <input
            step='12'
            min='12'
            name='commitment'
            value={commitment}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>
        <div className={classes.alignHorizontal}>
          <span>Leasing</span>
          <label className='switch'>
            <input name='leasing' checked={leasing} onChange={onInputChange} id='btnToggleBillingDoc' type='checkbox' />
            <div className='slider round' />
          </label>
          <label htmlFor='inputCost'>
            <span className='icon icon-plus' />
          </label>
          <input
            step='12'
            min='12'
            name='leasingCost'
            value={leasingCost}
            onChange={onInputChange}
            type='number'
            className='form-control inputQuantity'
            id='inputCost'
            placeholder='...'
          />
        </div>
      </div>

      <button onClick={onSubmit} type='button' className='btn btn-sm btn-success'>
        Sauvegarder
      </button>

      <span onClick={toggleMenu} id='appBillingTotal-Close' className='icon icon-cross' />
    </div>
  );
};

export default BillingTotalMenu;
